import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EndChatDialogDialogComponent } from '@components/dialogs/end-chat-dialog/end-chat-dialog.component';
import { CreateTabulationI, TabulationI } from '@interfaces/tabulation.interface';
import { TabulationsByChannelEntry } from '@interfaces/tabulations-by-channel-entry.interface';
import { CallTabulationInfoI, InputDataTypeEndChatDialog } from '@omnitypes/end-attendance.type';
import { ParametersHttpService } from '@services/parameters/parameters-http.service';
import { TabulationService } from '@services/tabulation/tabulation.service';
import { firstValueFrom } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

/**
 * Opens the call wrap-up (tabulation) modal, decoupled from SipService so it can be reopened
 * from the app initializer after a page refresh, without a live SIP session.
 */
@Injectable({ providedIn: 'root' })
export class TabulationDialogService {
  constructor(
    private readonly dialog: MatDialog,
    private readonly tabulationService: TabulationService,
    private readonly parametersService: ParametersHttpService
  ) {}

  public async openCallTabulation(
    callInfo?: CallTabulationInfoI,
    isPending = false
  ): Promise<CreateTabulationI | undefined> {
    const tabulations: TabulationI[] = await firstValueFrom(this.tabulationService.tabulations$);

    if (!tabulations?.length) {
      return;
    }

    const dialogRef = this.dialog.open(EndChatDialogDialogComponent, {
      id: 'modal-end-chat',
      width: '400px',
      panelClass: 'custom-dialog-v2',
      disableClose: true,
      data: {
        title: 'CONFIRM_END_TO_CALL',
        titleTabulation: 'TABULATION_BY_CALL',
        titleCenter: true,
        actions: true,
        isChat: false,
        tabulations: [{ tabulations, channelId: uuidv4() }],
        callInfo,
        isPending,
        mandatoryTabulationParameterResponse: await firstValueFrom(
          this.parametersService.mandatoryTabulationParameterSubject.asObservable()
        ),
      } as InputDataTypeEndChatDialog,
    });

    const result: TabulationsByChannelEntry[] | 'cancel' = await firstValueFrom(dialogRef.afterClosed());

    if (result && result.length && result !== 'cancel') {
      return {
        tabulationIds:
          result[0]?.tabulations
            ?.map((tabulation) => tabulation._id)
            .filter((id): id is string => typeof id === 'string') || [],
        commentTabulation: result[0].commenter ? result[0].commenter : undefined,
      };
    }

    return;
  }
}
